import { createApi } from './axiosInstance';
import { normaliseLoginName } from '../config/countryCallingCodes';

// Razorpay payments (fpo service: PaymentController.java, PaymentAdminController.java).
const api = createApi('myFPO');

// Signed-in users: service subscriptions
export const createSubscriptionOrder = (subscriptionPlanId, serviceKey) =>
  api.post('/payments/subscription/orders', { subscriptionPlanId, serviceKey });
export const verifyPayment = (orderId, paymentId, signature) => api.post('/payments/verify', { orderId, paymentId, signature });
export const paymentWindowClosed = (orderId) => api.post('/payments/cancelled', { orderId });
export const getMyPayments = () => api.get('/payments/my');
// Paid plans approved with the FPO / Company registration, waiting for the user's online payment
export const getAwaitingPayments = () => api.get('/payments/awaiting');
export const getReceipt = (id) => api.get(`/payments/${id}/receipt`);

// The one-time membership fee right after registering or from the Sign-in page (email/mobile + password, then a token)
export const startMembershipFee = (login, password) => api.post('/membership-fee/start', { login: normaliseLoginName(login), password });
export const createMembershipOrder = (token) => api.post('/membership-fee/orders', { token });
export const verifyMembershipPayment = (token, orderId, paymentId, signature) =>
  api.post('/membership-fee/verify', { token, orderId, paymentId, signature });
export const membershipWindowClosed = (token, orderId) => api.post('/membership-fee/cancelled', { token, orderId });
// A signed-in guest: whether the account is a guest until the fee is paid, and starting the payment (GuestMembershipBanner)
export const getMembershipGuest = () => api.get('/payments/membership');
export const startMembershipFeeSignedIn = () => api.post('/payments/membership/start');

// System Administrators
export const getPaymentSettings = () => api.get('/admin/payments/settings');
export const savePaymentSettings = (data) => api.put('/admin/payments/settings', data);
// Razorpay mode (Test / Live) and keys; secrets are never returned, only whether set and their last 4 characters
export const getRazorpaySettings = () => api.get('/admin/payments/razorpay');
export const saveRazorpaySettings = (data) => api.put('/admin/payments/razorpay', data);
export const checkRazorpayKeys = (mode, keyId, keySecret) => api.post('/admin/payments/razorpay/check', { mode, keyId, keySecret });
export const getPaymentTransactions =(params = {}) => api.get('/admin/payments/transactions', { params });
export const checkPaymentNow = (id) => api.post(`/admin/payments/transactions/${id}/check`);
export const markPaymentRefunded = (id, note) => api.post(`/admin/payments/transactions/${id}/refunded`, { note });
export const getAdminReceipt = (id) => api.get(`/admin/payments/transactions/${id}/receipt`);
export const getMembershipStatus = (userIds) => api.get('/admin/payments/membership-status', { params: { userIds: userIds.join(',') } });
